import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export class ValidateControls {

static  optionalCharValidator(length): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value || value.trim() === '0') {
      return null; // Not required
    }

    return value.length === length
      ? null
      : { invalidLength: { requiredLength: length, actualLength: value.length   } };
  };
}
static  optionalCharValidatorRange(minLength , maxLength): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value || value.trim() === '0'|| value.trim() === 0) {
      return null; // Not required
    }

    return value.length >= minLength && value.length<=maxLength
      ? null
      : { invalidLength: { requiredLength: minLength, actualLength: value.length   } };
  };
}
  static IsValidArabic(control: AbstractControl): ValidationErrors | null {

    const text = control.value;
    var regex = new RegExp("^[\u0600-\u06FF\u003A\0-9s]{0,4000}$");
    return text == null || regex.test(text)
      ? null
      : { IsValidArabic: true };
  };
  static IsValidTextNotContainsNumbers(control: AbstractControl): ValidationErrors | null {

    const text = control.value;
    var regex = new RegExp(/\d+/g);
    return text == null || !regex.test(text)
      ? null
      : { IsValidTextNotContainsNumbers: true };
  };



  static IsValidEnglish(control: AbstractControl): ValidationErrors | null {

    const text = control.value;
    var regex = new RegExp("^[A-Za-z0-9\\s<>!@#$%^&*()_+=-`~\\\]\[{}|';:/.,?]*$");
    return text == null || regex.test(text)
      ? null
      : { IsValidEnglish: true };
  };
  static IsValidEnglishNoSpace(control: AbstractControl): ValidationErrors | null {

    const text = control.value;
    var regex = new RegExp("^[A-Za-z0-9]*$");
    return text == null || regex.test(text)
      ? null
      : { IsValidEnglishNoSpace: true };
  };
  static IsValidNumber(control: AbstractControl): ValidationErrors | null {

    const text = control.value;
    var regex = new RegExp("^[0-9]\\d*(\\.\\d+)?$");
    return text == null || regex.test(text)
      ? null
      : { IsValidNumber: true };
  };

  // static IsValidNumber(control: AbstractControl): Promise<ValidationErrors | null> {
  //   return new Promise(resolve => {
  //     setTimeout(() => {
  //       const text = control.value;
  //       var regex = new RegExp("^[0-9]\\d*(\\.\\d+)?$");
  //       if (text == null || regex.test(text)) {
  //         resolve({ IsValidNumber: true }); // Return error object
  //       } else {
  //         resolve(null); // No error
  //       }
  //     }, 1000);
  //   });
  // }


  static IsValidUrl(control: AbstractControl): ValidationErrors | null {

    const text = control.value;
    var regex = new RegExp("^(http[s]?:\/\/).*$");
    return text == null || regex.test(text)
      ? null
      : { IsValidUrl: true };
  };

  static dateValidator: ValidatorFn = (
    control: AbstractControl
  ): ValidationErrors | null => {
    const start = control.get('dateFrom').value;
    const end = control.get('dateTo').value;

    if (start == null || end == null)
      return null;

    const sTime = new Date(start).setHours(0, 0, 0, 0);
    const eTime = new Date(end).setHours(0, 0, 0, 0);
    const ret =
      sTime <= eTime
        ? null
        : { dateInValid: true };
    return ret;
  };


  static dateValidatorForSpecificValues: ValidatorFn = (
    control: AbstractControl
  ): ValidationErrors | null => {
    const start = control.get('ContractStartDate').value;
    const end = control.get('ContractEndDate').value;

    if (start == null || end == null)
      return null;

    const sTime = new Date(start).setHours(0, 0, 0, 0);
    const eTime = new Date(end).setHours(0, 0, 0, 0);
    const ret =
      sTime <= eTime
        ? null
        : { dateInValid: true };
    return ret;
  };




  static IsValidVisitorId(control: AbstractControl): ValidationErrors | null {

    const text = control.value;
    var regex = new RegExp("^(1|2)[0-9]{9}$");
    return text == null || regex.test(text)
      ? null
      : { IsValidVisitorId: true };
  };
}